import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography, useTheme } from "@mui/material";
import ArrowDownIcon from "@icons/myicons/arrow-down.svg?react";

export const ShowMoreTypography = ({
  showMore,
  setShowMore,
  marginTop,
}: {
  showMore: boolean;
  setShowMore: (showMore: boolean) => void;
  marginTop?: number;
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      onClick={() => setShowMore(!showMore)}
      gap={2}
      mt={marginTop}
      sx={{
        color: theme.palette.icon.active,
        cursor: "pointer",
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        sx={{
          transform: showMore ? "rotate(180deg)" : "rotate(360deg)",
        }}
      >
        <ArrowDownIcon width="24px" height="24px" />
      </Box>
      <Typography variant="body1">
        {showMore
          ? t("recommender.compareView.donutCharts.showLess")
          : t("recommender.compareView.donutCharts.showMore")}
      </Typography>
    </Box>
  );
};
